import styled from 'styled-components';
import { focusStyles } from '../../styled/focus';

export const StyledLabel = styled.label`
  margin-bottom: 0;
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  display: flex;
  line-height: ${({ theme }) => theme.lineHeights.paragraph};
  font-weight: ${({ $defaultChecked }) =>
    $defaultChecked ? 'bold' : 'normal'};
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.palette.disabled : theme.palette.standardText};
`;

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  & + ${StyledLabel} {
    &::before {
      content: '';
      display: inline-block;
      min-width: ${({ theme }) => theme.spacing.medium};
      max-height: ${({ theme }) => theme.spacing.medium};
      padding: 4px;
      margin-right: ${({ theme }) => theme.spacing.tiny};
      background-clip: content-box;
      border-radius: 50%;
      border: 2px solid;
      border-color: ${({ $error, theme, disabled }) => {
        if (disabled) {
          return `${theme.palette.disabled} !important`;
        }
        if ($error) {
          return theme.palette.errorBorder;
        }
        return theme.palette.borderDark;
      }};
    }
  }

  &:checked + ${StyledLabel} {
    &::before {
      background-color: ${({ theme }) => theme.palette.borderDark};
    }
  }

  &:focus + ${StyledLabel}, &:hover + ${StyledLabel} {
    &::before {
      border-color: ${({ theme }) => theme.palette.brand};
    }
  }

  &:focus + ${StyledLabel} {
    &::before {
      ${focusStyles}
    }
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
